import { render, staticRenderFns } from "./v-switch.vue?vue&type=template&id=245d99ee&scoped=true&"
import script from "./v-switch.vue?vue&type=script&lang=ts&"
export * from "./v-switch.vue?vue&type=script&lang=ts&"
import style0 from "./v-switch.vue?vue&type=style&index=0&id=245d99ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245d99ee",
  null
  
)

export default component.exports